















































import Vue from 'vue'
import Component from 'vue-class-component'
import api from '@/api/member'

@Component
export default class Login extends Vue {
  // @Getter('profile') account: Object
  // @Getter('token') token: string
  // @Action('login') login: Function
  
  checked = true
  LoginForm = {
    account: '',
    password: ''
  }
  logining = false
  rule = {
    // account: [
    //   {
    //     required: true,
    //     max: 20,
    //     min: 6,
    //     message: '用户名不能为空，长度为6-20位',
    //     trigger: 'blur'
    //   }
    // ],
    // password: [
    //   {
    //     required: true,
    //     message: '密码不能为空！',
    //     trigger: 'blur'
    //   }
    // ]
  }
  token: any = ''
  account: any = ''

  // mounted () {
  //   this.getCookie()
  // }
  get _isMobile() {
    let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
    return flag;
  }

  submit () {
    let LoginForm = this.$refs.LoginForm as HTMLFormElement
    LoginForm.validate((valid: boolean) => {
      if (valid) {
        this.logining = true
        let params = {
          account: this.LoginForm.account,
          password: this.LoginForm.password
        }
        api.login(params).then((res) => {
          let account = res.enterprise
          let token = res.token
          if (account) {
            this.logining = false
            this.$message({
              message: '登录成功！',
              type: 'success'
            })
            // if (this.checked) {
            //   this.setCookie(this.LoginForm.account, this.LoginForm.password, 7)
            // } else {
            //   this.clearCookie()
            // }
            localStorage.setItem('enterprise', JSON.stringify(account))
            localStorage.setItem('enterpriseToken', token)
            this.$router.push({name: 'dashboard-index'})
            // if(account.need_change_password) {
            //   this.$router.push({name: 'change-password'})
            // } else {
            //   this.$router.push({name: 'dashboard-index'})
            // }
            
          }
        }).catch((error: any) => {
          this.logining = false
        })
      } else {
        this.logining = false
        this.message('登录失败！')
      }
    })
  }

  message (msg: string) {
    this.$message({
      message: msg,
      type: 'error'
    })
  }

  // setCookie (account: string, password: string, days: any) {
  //   let date = new Date()
  //   date.setTime(date.getTime() + 24 * 60 * 60 * 1000 * days) // 保存的天数
  //   // 字符串拼接cookie
  //   window.document.cookie = 'account' + '=' + account + ';path=/;expires=' + date.toUTCString()
  //   window.document.cookie = 'password' + '=' + password + ';path=/;expires=' + date.toUTCString()
  // }
  // getCookie () {
  //   if (document.cookie.length > 0) {
  //     let arr = document.cookie.split('; ') // 显示的格式需要切割一下自己可输出看下
  //     for (let i = 0; i < arr.length; i++) {
  //       let arr2 = arr[i].split('=') // 再次切割
  //       if (arr2[0] === 'account') { // 判断查找相对应的值
  //         this.LoginForm.account = arr2[1] // 保存到保存数据的地方
  //       } else if (arr2[0] === 'password') {
  //         this.LoginForm.password = arr2[1]
  //       }
  //     }
  //   }
  // }

  // clearCookie () { // 清除cookie
  //   this.setCookie('', '', -1) // 修改2值都为空，天数为负1天就好了
  // }

  reset () {
    (<HTMLFormElement> this.$refs.LoginForm).resetFields()
  }
}
